import React, { useState } from "react";
import { Box, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { PresentationModeList } from "./PresentationModeList";
import { usePresentationModeStore } from "../../stores/selectedToViewStore";

export const PresentationSidebar: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const clearPresentationState = usePresentationModeStore((state) => state.clearPresentationState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const exitPresentationMode = () => {
    clearPresentationState();
    const newParams = new URLSearchParams(searchParams);
    newParams.delete("presentation");
    setSearchParams(newParams);
    handleMenuClose();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
        backgroundColor: "#fafafa",
      }}
    >
      {/* כותרת מצב תצוגה */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "24px 16px 16px",
          background: "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)",
          borderBottom: "2px solid rgba(0, 0, 0, 0.08)",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
        }}
      >
        <Box sx={{ width: "40px" }} /> {/* ספייסר */}
        <Typography
          variant="h6"
          sx={{
            color: "#424242",
            fontWeight: 600,
            letterSpacing: "0.5px",
            fontSize: "18px",
          }}
        >
          מצב תצוגה
        </Typography>
        <IconButton
          onClick={handleMenuOpen}
          size="small"
          sx={{
            color: "#616161",
          }}
        >
          <MoreVertIcon />
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={exitPresentationMode}>
          <ExitToAppIcon sx={{ marginLeft: 1, fontSize: 20 }} />
          צא ממצב תצוגה
        </MenuItem>
      </Menu>

      <Box sx={{ marginTop: "16px", flex: 1, overflow: "auto", maxHeight: "50vh" }}>
        <PresentationModeList />
      </Box>
    </Box>
  );
};
